module.exports = __webpack_public_path__ + "img/exclamation-circle.aa5eae65.svg";